import axios from "api/axios";
import { urlEncode } from "api/api-utils";

const api = {
  getEmissionsTotal({ year, dimensionItemIds, quarter }, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    // Only send quarter when a specific one is picked — null/"ALL" lets the
    // backend default (Quarter.ALL = whole year) apply.
    const quarterParam = quarter && quarter !== "ALL" ? `&quarter=${quarter}` : "";
    return axios.get(`/insights/total?${dimensionItemIds}&year=${year}${quarterParam}`, config).then(({ data }) => data);
  },

  // SECR consumption view (energy / water / waste / on-site generation). Same
  // period + dimension-filter query shape as getEmissionsTotal — dimensionItemIds
  // is a pre-serialized fragment (e.g. "dimensionOne=1,2&dimensionTwo=3").
  getConsumption({ year, dimensionItemIds, quarter }, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    const quarterParam = quarter && quarter !== "ALL" ? `&quarter=${quarter}` : "";
    return axios.get(`/insights/consumption?${dimensionItemIds}&year=${year}${quarterParam}`, config).then(({ data }) => data);
  },

  getSupplierOverview({ years, categories, dataQuality, scope }, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios
      .get(
        `/insights/suppliers?categories=${urlEncode(categories)}&years=${urlEncode(years)}&dataQuality=${urlEncode(dataQuality)}&scope=${urlEncode(scope)}`,
        config
      )
      .then(({ data }) => data);
  },

  getSupplierEngagementReports({ years, supplierId }, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios
      .get(`/insights/suppliers/engagement?years=${urlEncode(years)}&supplierId=${urlEncode(supplierId)}`, config)
      .then(({ data }) => data);
  },
};

export { api as EmissionsInsightsApi };
